import {useEffect} from 'react'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'

const useGetAccountParticipationTicket = () => {
	const [fetchResult, fetchRequest] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	const fetch = () => {
		fetchRequest('GET', '/account/participation-ticket')
	}

	useEffect(() => {
		fetch()
	}, [])

	return [fetchResult, fetch]
}

export default useGetAccountParticipationTicket
